import TermList from "../AdminTermList";

export default class AdminTermListUserProductionDetailType extends TermList {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "user_production_detail_type";
    }
}
